<template>
  <!-- 文章列表 -->
  <div class="controlGroup">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['分组控销', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增分组</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleStatus('', 'D')"
          >批量删除</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="状态"
          style="width: 100px; margin-right: 10px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="启用" value="Y"></el-option>
          <el-option label="禁用" value="N"></el-option>
        </el-select>
        <label class="label">组类型：</label>
        <el-select
          v-model="searchForm.type"
          placeholder="组类型"
          style="width: 100px; margin-right: 10px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="商品组" value="商品组"></el-option>
          <el-option label="客户组" value="客户组"></el-option>
          <el-option label="企业组" value="企业组"></el-option>
          <el-option label="区域组" value="区域组"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 10px"
          clearable
          placeholder="组名称"
        ></el-input>
        <el-input
          v-model="searchForm.info"
          style="width: 200px; margin-right: 10px"
          clearable
          placeholder="组明细筛选"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleRefresh"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" type="index">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="分组编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="名称"
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="addTime"
        label="时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 'N'">已禁用</el-tag>
          <el-tag type="success" v-if="scope.row.status == 'Y'">已启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleBind(scope.row)"
            >管理</el-button
          >
          <!-- <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row.id, 'D')"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 新增分组 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑分组</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="50px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="名称" prop="name">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select
                v-model="addForm.type"
                placeholder="请选择"
                style="width: 100%"
                :disabled="!!addForm.id"
              >
                <el-option label="商品组" value="商品组"></el-option>
                <el-option label="客户组" value="客户组"></el-option>
                <el-option label="企业组" value="企业组"></el-option>
                <el-option label="区域组" value="区域组"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select
                v-model="addForm.status"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="启用" value="Y"></el-option>
                <el-option label="禁用" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "controlGroup",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        name: "",
        info: "",
        status: "",
        type: "",
      },
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: "",
        name: "",
        type: "商品组",
        status: "Y",
      },
      addFormRule: {
        name: [mustFill],
        type: [mustFill],
        status: [mustFill],
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData() {
      let data = {
        type: "ControlSummaryList",
        mold: this.searchForm.type,
        status: this.searchForm.status,
        parameter: this.searchForm.name,
        conditions: this.searchForm.info,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };
      let proc = "Proc_OperationControl"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage = 1;
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = (res.data || []).map((item) => ({
              id: item.Id,
              code: item.Code,
              name: item.Name,
              type: item.Mold,
              addTime: item.RecordTime,
              status: item.Beactive,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**更改状态 */
    handleStatus(id, status) {
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == "Y") {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == "N") {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == "D") {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          id = id || this.selectedList.map((item) => item.id).join(",");
          let data = {
            type: "ControlSummaryProcessing",
            list: id,
            ident: status,
          };
          let proc = "Proc_OperationControl"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    handleBind(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(
          JSON.stringify({ id: row.id, type: row.type })
        );
      } else {
        prams = row;
      }
      this.$router.push({
        path: "controlGroupInfo",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (const key in this.addForm) {
          this.addForm[key] = row[key];
        }
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addForm.type = "商品组";
      this.addForm.status = "Y";
      this.addDrawer = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "ReplaceControlSummary",
            id: this.addForm.id,
            name: this.addForm.name,
            mold: this.addForm.type,
            status: this.addForm.status,
          };
          let proc = "Proc_OperationControl"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "rechargeorder/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.controlGroup {
  width: 100%;
  height: 100%;
}
</style>
